import { isNum } from '../helpers';

export default {
    methods: {
        addFiltersToUrl(filters) {
            let [queryString, queryStringPrefix] = ['', '?'];

            for (let [key, value] of Object.entries(filters)) {
                if (!key || !value) {
                    continue;
                }

                if (!Array.isArray(value)) {
                    queryString += `${ key }=${ value }&`;
                } else {
                    value.forEach((item, idx) => {
                        queryString += `${ key }[]=${ item }&`;
                    });
                }
            }

            if (queryString) {
                queryString = queryStringPrefix + queryString;
            }

            if (!queryString) {
                window.history.pushState({ title: 'Update filters url' }, '', window.location.pathname)
            } else {
                window.history.pushState({ title: 'Update filters url' }, '', queryString)
            }
        },
        getFiltersFromUrl() {
            const params = this.$route.query;
            const updated = {};

            for (let [key, value] of Object.entries(params)) {
                if (!key || !value) {
                    continue;
                }

                const keyUpdated = key.replace('[]', '');

                const getTargetValue = (val) => val === 'true' ? 1 : isNum(val) ? +val : val;

                if (Array.isArray(value)) {
                    updated[keyUpdated] = [];
                    value.forEach(item => {
                        updated[keyUpdated].push(getTargetValue(item))
                    });
                } else {
                    if (key.indexOf('[]') > -1) {
                        updated[keyUpdated] = [];
                        updated[keyUpdated].push(getTargetValue(value))
                    } else {
                        updated[keyUpdated] = getTargetValue(value);
                    }
                }
            }

            return updated;
        },
    },
}
